export default function WhiteSpace({ width, height }: { width?: string, height?: string }) {
  // flexShrink: 0 because a spacer that collapses is no spacer. Inside a flex column such as the
  // Charges page's PageColumn these were being shrunk from 8px to 1px, closing up the gaps around
  // the search bar row.
  return (
    <div style={{ width: width ?? '0px', height: height ?? '0px', flexShrink: 0 }}></div>
  )
}
